import { defineComponent, h } from 'vue';
import utils from '../../../../Shared/utils.jsx';
import methods from '../../../../Shared/methods';

export default defineComponent({
    name: 'form-paragraph-dsgn',
    data: function () {
        return {
        }
    },
    created() {
    },
    computed: {
        ...utils.forms.computed,
        selected$: function () {
            return this.Root.SelectedNode && this.Root.SelectedNode == this;
        },
    },
    methods: {
        ...methods,
        handleClick(e) {
            this.Root.SelectNode(this);
            e.cancelBubble = true;
            e.stopPropagation();
        },
        sync(value) {
            this.schema.body = value;
        }
    },
    props: {
        name: '',
        schemakey: '',
        root: null,
        designmodel: null,
        schema: null,
        cmodel: null,
        extra: null,
        readonly: false,
        child: 0,
    },
    render() {
        let content;
        if (this.selected$)
            content = (
                <div
                    style={{
                        position: 'relative',
                        zIndex: 35,
                    }}
                    onClick={(e) => e.stopPropagation()}
                    onMousedown={(e) => e.stopPropagation()}
                >
                    <textarea
                        style={{
                            display: "block",
                            width: "100%",
                            maxWidth: "100%",
                            boxSizing: "border-box",
                            minWidth: 0,
                            resize: "vertical",
                            position: "relative",
                        }}
                        value={this.schema.body ?? ''}
                        onInput={(e) => this.sync(e.target.value)}
                    />
                </div>
            );
        else
            content = this.schema.body;

        return (
            <div
                class={{ 'designer-form': true }}
                style={{
                    xmarginLeft: (this.child * 15) + 'px',
                    position: 'relative',
                    padding: '5px',
                    whiteSpace: 'normal',
                    boxSizing: 'border-box',
                    width: '100%',
                    minWidth: 0,
                }}
                onClick={(e) => this.handleClick(e)}>
                <div class={{ "designer-container-hovering": true, 'designer-container-selected': this.selected$ }}></div>
                {content}
            </div>
        );
    }
});
